<template>
  <div class="pc-home">
    <!-- 成片库素材库 -->
    <div class="top_nav main">
      <div
        @click="checkTab"
        v-for="(item,index) in titleArray"
        :id="index"
        :class="[nn,index == id ?'active':'']"
        :key="item.id"
      >
        <el-image style="pointer-events: none;" :src="item.src"></el-image>
        <span style="vertical-align:middle;pointer-events: none;">{{item.title}}</span>
        <span style="font-size:16px;color:#637283;pointer-events: none;">{{item.engname}}</span>
        <!-- <span
          style="color:#637283;font-size:16px;"
          v-if="index==id"
          class="fr"
          @click="goHighSearch(index)"
        >MORE &gt;</span>-->
      </div>
      <!-- <div @click="checkTab" id="" class="nn ">成片库</div>
      <div @click="checkTab" class="nn">素材库</div>-->
    </div>
    <div class="h-box main">
      <!-- 小梅花 -->
      <div v-if="roleId == 6 || roleId == 7 || roleId == 8 || roleId == 9" title="点击进入小梅花导航类" class="h-li">
        <div class="flex-row" @click="goFlowsPage">
          <div class="li_title flows">小梅花</div>
          <!-- <div class="li_type">
            <el-image :src="timeSrc"></el-image>
            <div class="f16">总时长（分钟）</div>
            <div class="red">{{flowsList.totalTime}}</div>
          </div>
          <div class="li_type">
            <el-image :src="sizeSrc"></el-image>
            <div class="f16">总体积（{{flowsList.SizeUnit}}）</div>
            <div class="red">{{flowsList.totalSize}}</div>
          </div> -->
        </div>

        <div class="li_image" >
          <ul>
            <li class="li" v-for="(item,index) in flowsList" :key="item.id" v-show="index <= 4">
              <div class="li-box">
                <el-image
                  v-on:error="dosomething($event,item.fileLocation)"
                  v-bind:alt="item.fileName"
                  @click="goImageDetail(item.id)"
                  :src="item.fileLocation"
                  fit="cover"
                ></el-image>
              </div>
              <p class="li-title">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
        <div style="float:right;margin-left:50px">
          <!-- 跳转到小梅花列表页 -->
          <el-button @click="goFlowsPage" type="primary">跳转到小梅花列表页</el-button>
        </div>
      </div>
      <!-- 新闻类 -->
      <div title="点击进入新闻类导航" class="h-li">
        <div class="flex-row" @click="goSearchPage">
          <div class="li_title news">新闻类</div>
          <div class="li_type">
            <el-image :src="timeSrc"></el-image>
            <div class="f16">总时长（分钟）</div>
            <div class="red">{{newsList.totalTime}}</div>
          </div>
          <div class="li_type">
            <el-image :src="sizeSrc"></el-image>
            <div class="f16">总体积（{{newsList.SizeUnit}}）</div>
            <div class="red">{{newsList.totalSize}}</div>
          </div>
        </div>

        <div class="li_image">
          <ul>
            <li
              class="li"
              v-for="(item,index) in newsList.videoInfoList"
              :key="item.id"
              v-show="index <= 3"
            >
              <div class="li-box">
                <el-image
                  v-on:error="dosomething($event,item.fileLocation)"
                  v-bind:alt="item.fileName"
                  @click="goImageDetail(item.id)"
                  :src="item.fileLocation"
                  fit="cover"
                ></el-image>
              </div>
              <p class="li-title">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 直播类 -->
      <div title="点击进入直播类导航" class="h-li">
        <div class="flex-row" @click="Livego">
          <div class="li_title live">直播类</div>
          <div class="li_type">
            <el-image :src="timeSrc"></el-image>
            <div class="f16">总时长（分钟）</div>
            <div class="red">{{liveList.totalTime}}</div>
          </div>
          <div class="li_type">
            <el-image :src="sizeSrc"></el-image>
            <div class="f16">总体积（{{liveList.SizeUnit}}）</div>
            <div class="red">{{liveList.totalSize}}</div>
          </div>
        </div>

        <div class="li_image">
          <ul>
            <li class="li" v-for="item in liveList.videoInfoList" :key="item.id">
              <div class="li-box">
                <el-image @click="goImageDetail(item.id)" :src="item.fileLocation" fit="cover"></el-image>
              </div>
              <p class="li-title">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 访谈类 -->
      <div title="点击进入访谈类导航" class="h-li">
        <div class="flex-row" @click="Viewgo">
          <div class="li_title view">访谈类</div>
          <div class="li_type">
            <el-image :src="timeSrc"></el-image>
            <div class="f16">总时长（分钟）</div>
            <div class="red">{{viewList.totalTime}}</div>
          </div>
          <div class="li_type">
            <el-image :src="sizeSrc"></el-image>
            <div class="f16">总体积（{{viewList.SizeUnit}}）</div>
            <div class="red">{{viewList.totalSize}}</div>
          </div>
        </div>

        <div class="li_image">
          <ul>
            <li class="li" v-for="item in viewList.videoInfoList" :key="item.id">
              <div class="li-box">
                <el-image @click="goImageDetail(item.id)" :src="item.fileLocation" fit="cover"></el-image>
              </div>
              <p class="li-title">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 作品类 -->
      <div title="点击进入作品类导航" class="h-li">
        <div class="flex-row" @click="Workgo">
          <div class="li_title work">作品类</div>
          <div class="li_type">
            <el-image :src="timeSrc"></el-image>
            <div class="f16">总时长（分钟）</div>
            <div class="red">{{workList.totalTime}}</div>
          </div>
          <div class="li_type">
            <el-image :src="sizeSrc"></el-image>
            <div class="f16">总体积（{{workList.SizeUnit}}）</div>
            <div class="red">{{workList.totalSize}}</div>
          </div>
        </div>

        <div class="li_image">
          <ul>
            <li class="li" v-for="item in workList.videoInfoList" :key="item.id">
              <div class="li-box">
                <el-image @click="goImageDetail(item.id)" :src="item.fileLocation" fit="cover"></el-image>
              </div>
              <p class="li-title">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 其他类 -->
      <div title="点击进入其他类导航" class="h-li">
        <div class="flex-row" @click="Othergo">
          <div class="li_title other">其他类</div>
          <div class="li_type">
            <el-image :src="timeSrc"></el-image>
            <div class="f16">总时长（分钟）</div>
            <div class="red">{{otherList.totalTime}}</div>
          </div>
          <div class="li_type">
            <el-image :src="sizeSrc"></el-image>
            <div class="f16">总体积（{{otherList.SizeUnit}}）</div>
            <div class="red">{{otherList.totalSize}}</div>
          </div>
        </div>

        <div class="li_image">
          <ul>
            <li class="li" v-for="item in otherList.videoInfoList" :key="item.id">
              <div class="li-box">
                <el-image @click="goImageDetail(item.id)" :src="item.fileLocation" fit="cover"></el-image>
              </div>
              <p class="li-title">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 平台视频数据总量 -->
    <div class="database main">
      <!-- 标题 -->
      <div class="data-title tac">
        <el-image :src="dataLogo"></el-image>
        <h2>平台视频数据总量</h2>
        <div>TOTAL PLANTFORM DATA</div>
      </div>
      <!--  -->
      <div class="data-tab">
        <div class="tab-box">
          <div class="tab-img bg-time">
            <el-image :src="timeSrc"></el-image>
          </div>
          <div style="padding:10px 15px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoTime}}</div>
            <div>视频总长（分钟）</div>
          </div>
        </div>
        <div class="tab-box">
          <div class="tab-img bg-size">
            <el-image :src="sizeSrc"></el-image>
          </div>
          <div style="padding:10px 15px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoSize}}</div>
            <div>视频总体积（{{videoGrossCount.SizeUnit}}）</div>
          </div>
        </div>
        <div class="tab-box">
          <div class="tab-img bg-total">
            <el-image :src="totalSrc"></el-image>
          </div>
          <div style="padding:10px 15px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoCount}}</div>
            <div>视频总数量（个）</div>
          </div>
        </div>
        <div class="tab-box">
          <div class="tab-img bg-video">
            <el-image :src="videoSrc"></el-image>
          </div>
          <div style="padding:10px 10px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoViewCount}}</div>
            <div>视频总播放量（次）</div>
          </div>
        </div>
      </div>
      <!-- 图表 -->
      <div class="data-chart">
        <el-row class="tal">
          <el-col class="tal" :span="6">
            <div id="myChart" :style="{width: '100%', height: '454px'}"></div>
          </el-col>
          <el-col :span="12" style="height:454px;">
            <div id="myChartPie" :style="{width: '100%', height: '454px'}"></div>
          </el-col>
          <el-col :span="6">
            <div id="myChart2" :style="{width: '100%', height: '454px'}"></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 热数据排行榜 -->
    <div class="data-rank">
      <div class="main">
        <!-- 标题 -->
        <div class="data-title tac">
          <el-image :src="rankLogo"></el-image>
          <h2>热数据排行榜</h2>
          <div>HOT DATA LEADERBOARD</div>
        </div>
        <!-- tab切换栏 -->
        <div class="top_nav main">
          <div
            @click="checkRankTab($event,index)"
            :class="[nn,'rank'+index == rid ?'ranlActive':'']"
            v-for="(item,index) in titleArray"
            :id="['rank'+ index]"
            :key="item.id"
          >
            <el-image style="pointer-events: none;" :src="item.src"></el-image>
            <span style="vertical-align:middle;pointer-events: none;">{{item.title}}</span>
            <span style="font-size:16px;color:#778493;pointer-events: none;">热数据排行榜</span>
            <!-- <span style="color:#637283;font-size:16px;pointer-events: none;" v-if="index==id" class="fr">MORE &gt;</span> -->
          </div>
          <!-- <div @click="checkTab" id="" class="nn ">成片库</div>
          <div @click="checkTab" class="nn">素材库</div>-->
        </div>
        <!-- 图片列表 -->
        <div class="rank-list">
          <el-row style="width:100%;">
            <!-- 搜索量 -->
            <el-col :span="8">
              <div class="top-title">
                <el-image :src="topSrc"></el-image>
                <div class="f20 font-weight">搜索量</div>
                <div class="text-color f14 ml">热数据TOP</div>
              </div>
              <div class="top-box">
                <ul>
                  <li class="top-li" v-for="(item,index) in searchList" :key="item.id">
                    <div class="li-img">
                      <el-image
                        @click="goImageDetail(item.id)"
                        fit="cover"
                        :src="item.fileLocation"
                      ></el-image>
                      <div
                        :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
                      >{{index + 1}}</div>
                    </div>
                    <div class="li-text">
                      <h3 class="red">{{item.viewcount}}</h3>
                      <h4>{{item.fileName}}</h4>
                      <div class="text-color f12">数据源：{{item.videoType == 1 ?'成片库':'素材库'}}</div>
                      <div class="text-color f12">格式：{{item.fileType}} </div>
                      <div class="text-color f12">时长：{{item.filePlayTime}}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </el-col>
            <!-- 播放量 -->
            <el-col :span="8">
              <div class="top-title">
                <el-image :src="topSrc"></el-image>
                <div class="f20 font-weight">播放量</div>
                <div class="text-color f14 ml">热数据TOP</div>
              </div>
              <div class="top-box">
                <ul>
                  <li class="top-li" v-for="(item,index) in playList" :key="item.id">
                    <div class="li-img">
                      <el-image
                        @click="goImageDetail(item.id)"
                        fit="cover"
                        :src="item.fileLocation"
                      ></el-image>
                      <div
                        :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
                      >{{index + 1}}</div>
                    </div>
                    <div class="li-text">
                      <h3 class="red">{{item.playcount}}</h3>
                      <h4>{{item.fileName}}</h4>
                      <div class="text-color f12">数据源：{{item.videoType == 1 ?'成片库':'素材库'}}</div>
                      <div class="text-color f12">格式：{{item.fileType}}</div>
                      <div class="text-color f12">时长：{{item.filePlayTime}}</div>

                    </div>
                  </li>
                </ul>
              </div>
            </el-col>
            <!-- 下载量 -->
            <el-col :span="8">
              <div class="top-title">
                <el-image :src="topSrc"></el-image>
                <div class="f20 font-weight">下载量</div>
                <div class="text-color f14 ml">热数据TOP</div>
              </div>
              <div class="top-box">
                <ul>
                  <li class="top-li" v-for="(item,index) in dowloadList" :key="item.id">
                    <div class="li-img">
                      <el-image
                        @click="goImageDetail(item.id)"
                        fit="cover"
                        :src="item.fileLocation"
                      ></el-image>
                      <div
                        :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
                      >{{index + 1}}</div>
                    </div>
                    <div class="li-text">
                      <h3 class="red">{{item.downloads}}</h3>
                      <h4>{{item.fileName}}</h4>
                      <div class="text-color f12">数据源：{{item.videoType == 1 ?'成片库':'素材库'}}</div>
                      <div class="text-color f12">格式：{{item.fileType}}</div>
                      <div class="text-color f12">时长：{{item.filePlayTime}}</div>

                    </div>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 平台内容纬度总量 -->
    <div class="data-wd main">
      <!-- 标题 -->
      <div class="data-title tac">
        <el-image :src="rankLogo"></el-image>
        <h2>平台内容纬度总量</h2>
        <div>TOTAL PLAYNTFORM CONTENT</div>
      </div>
      <!-- 图表 -->
      <div>
        <el-row>
          <el-col :span="6">
            <div class="wd-left tal">
              <div
                v-for="(item,index) in tabArray"
                @click="clickWdTab(index)"
                :key="item.id"
                :class="[ index == wdId ?'wd-adtive': '', 'wd-tab', 'mb']"
              >
                <div class="f18">{{item.name}}</div>
                <div v-if="index == 0" class="f18">
                  <!-- 视频标签总量 -->
                  <span
                    :style="index == wdId ? 'color:#4fb850;':''"
                  >{{videoGrossCount.videoTagsCount}}</span> 次
                </div>
                <div v-if="index == 1" class="f18">
                  <!-- 视频人物总量 -->
                  <span
                    :style="index == wdId ? 'color:#4fb850;':''"
                  >{{videoGrossCount.videoPersonCount}}</span> 人次
                </div>
                <div v-if="index == 2" class="f18">
                  <!-- 主办单位视频上传总量-->
                  <span
                    :style="index == wdId ? 'color:#4fb850;':''"
                  >{{videoGrossCount.videoCharCount}}</span> 个
                </div>
                <div v-if="index == 3" class="f18">
                  <!-- 涉及地区地点总量 -->
                  <span
                    :style="index == wdId ? 'color:#4fb850;':''"
                  >{{videoGrossCount.videoAddressCount}}</span> 个
                  <!-- <span>2345771</span>次 -->
                </div>
              </div>
              <!-- <div class="mt wd-tab">
                <div class="f18">视频标签总量</div>
                <div class="18"> <span> 39660865</span>次</div>
              </div>
              <div class="mt wd-tab">
                <div class="f18">视频标签总量</div>
                <div class="f18"> <span>39660865</span> 次</div>
              </div>
              <div class="mt wd-tab">
                <div class="f18">视频标签总量</div>
                <div class="f18"> <span>39660865</span> 次</div>
              </div>-->
            </div>
          </el-col>
          <el-col :span="18">
            <div v-if="tagType == 0" id="vc1" :style="{width: '100%', height: '454px'}"></div>
            <div v-if="tagType == 1" id="vc2" :style="{width: '100%', height: '454px'}"></div>
            <div v-if="tagType == 2" id="vc3" :style="{width: '100%', height: '454px'}"></div>
            <div v-if="tagType == 3" id="vc4" :style="{width: '100%', height: '454px'}"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      topSrc: require("../../assets/img/icon/top.png"),
      rankLogo: require("../../assets/img/icon/rank.png"),
      dataLogo: require("../../assets/img/icon/base.png"),
      timeSrc: require("../../assets/img/icon/time.png"),
      sizeSrc: require("../../assets/img/icon/size.png"),
      totalSrc: require("../../assets/img/icon/total.png"),
      videoSrc: require("../../assets/img/icon/play.png"),
      titleArray: [
        {
          id: 1,
          title: "成片库",
          src: require("../../assets/img/icon/video.png"),
          engname: "MATERIAL LIBRARY"
        },
        {
          id: 0,
          title: "素材库",
          src: require("../../assets/img/icon/sucai.png"),
          engname: "FINISHED PRODUCT LIBRARY"
        }
      ],
      id: 0,
      rid: "rank0",
      nn: "nn",
      videoTypeId: 1, // 0=素材 1=成片
      otherList: {}, // 其他类
      newsList: {}, // 新闻类
      viewList: {}, // 访谈类
      workList: {}, // 作品类
      liveList: {}, // 直播类
      tagChart: {}, //
      searchList: {}, // 搜索量
      playList: {}, // 播放量
      dowloadList: {}, // 下载量
      linum: "li-num",
      bgYellow: "bg-yellow",
      tabArray: [
        {
          id: 0,
          name: "视频标签总量",
          count: "123325"
        },
        {
          id: 1,
          name: "视频人物总量",
          count: "123325"
        },
        {
          id: 2,
          name: "主办单位上传数量",
          count: "123325"
        },
        {
          id: 3,
          name: "涉及地区地点总量",
          count: "123325"
        }
      ],
      wdId: 0,
      // 视频播放总量
      videoGrossCount: {},
      // 平台纬度+
      nodes: [],
      edges: [],
      tagType: 0,
      piedata: {},
      flowsList: [], //小梅花视频列表
       roleId: '',//角色id
    };
  },
  methods: {
    // 获取 小梅花 视频列表
    getFlowsList: async function() {
      var res = await this.$http.get(`/v1/videoInfo/getPrizeList?page=1&category=`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.flowsList = data;

        // console.log("////////////", data);
      }
    },
    goFlowsPage() {
      this.$router.push({
        path: "/flowpage",
        query: {
          type: "flow"
        }
      });
    },
    dosomething: function(e, srcOld) {
      // console.log(e)
      // e.currentTarget.src = srcOld
    },
    goHighSearch: function(index) {
      var videoTypeId = index == 1 ? 0 : 1;
      this.$router.push({
        path: "/videolist2",
        query: {
          from: 0,
          isClear: 0,
          vv: videoTypeId
        }
      });
    },
    // 单个视频查看详情
    goImageDetail: async function(id) {
      var res = await this.$http.post(`/v1/videoInfo/videoStatus?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$router.push({
          path: "/videodetail2",
          query: {
            id: id,
            status: 0
          }
        });
      } else {
        this.$message.error(message);
      }
    },
    // 视频播放总量
    videoInfoGrossCount: async function() {
      var res = await this.$http.get("/v1/index/videoInfoGrossCount");
      var { code, data, message } = res.data;
      if (code == 0) {
        this.videoGrossCount = data;
        this.getTagChart();
      }
    },
    getTagChart: async function() {
      var res = await this.$http.get("/v1/index/TagChart");
      var { code, message, data } = res.data;
      if (code == 0) {
        this.tagChart = data;
      }
    },
    // 新闻
    goSearchPage: function() {
      this.$router.push({
        path: "/searchpages",
        query: {
          type: "NEWS"
        }
      });
    },
    // 直播
    Livego: function() {
      this.$router.push({
        path: "/searchpages",
        query: {
          type: "LIVE"
        }
      });
    },
    // 访谈
    Viewgo: function() {
      this.$router.push({
        path: "/searchpages",
        query: {
          type: "VIEW"
        }
      });
    },
    // 作品
    Workgo: function() {
      this.$router.push({
        path: "/searchpages",
        query: {
          type: "WORKS"
        }
      });
    },
    // 其他
    Othergo: function() {
      this.$router.push({
        path: "/searchpages",
        query: {
          type: "OTHER"
        }
      });
    },
    checkTab: function(e) {
      console.log(e);
      // this.videoTypeId = e.target.id
      if (e.target.id == 0) {
        this.videoTypeId = 1;
      } else {
        this.videoTypeId = 0;
      }
      this.id = e.target.id;
      this.$store.commit("changeTypeId", this.videoTypeId);
      this.getListByContent();
    },
    checkRankTab: function(e, index) {
      console.log(e.target.id);
      if (index === 0) {
        this.videoTypeId = 1;
      } else {
        this.videoTypeId = 0;
      }
      this.rid = e.target.id;
      // this.videoTypeId = index
      this.getRankList();
    },
    // 获取列表
    getListByContent: async function() {
      var res = await this.$http.get(
        `/v1/index/videoInfoByContentType?videoTypeId=${this.videoTypeId}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        // 成片库 素材库
        this.otherList = data.OTHER;
        if (JSON.stringify(this.otherList) !== "{}") {
          if (this.otherList.videoInfoList.length > 4) {
            this.otherList.videoInfoList = this.otherList.videoInfoList.slice(
              0,
              4
            );
          }
        }
        this.newsList = data.NEWS;
        // console.log(this.newsList);
        if (JSON.stringify(this.newsList) !== "{}") {
          if (this.newsList.videoInfoList.length > 4) {
            this.newsList.videoInfoList = this.newsList.videoInfoList.slice(
              0,
              4
            );
          }
        }
        this.viewList = data.VIEW;
        if (JSON.stringify(this.viewList) !== "{}") {
          if (this.viewList.videoInfoList.length > 4) {
            this.viewList.videoInfoList = this.viewList.videoInfoList.slice(
              0,
              4
            );
          }
        }
        this.workList = data.WORKS;
        if (JSON.stringify(this.workList) !== "{}") {
          if (this.workList.videoInfoList.length > 4) {
            this.workList.videoInfoList = this.workList.videoInfoList.slice(
              0,
              4
            );
          }
        }
        this.liveList = data.LIVE;
        if (JSON.stringify(this.liveList) !== "{}") {
          if (this.liveList.videoInfoList.length > 4) {
            this.liveList.videoInfoList = this.liveList.videoInfoList.slice(
              0,
              4
            );
          }
        }
        // 热数据排行榜 DOWNLOADS PLAYCOUNT VIEWCOUNT
        // this.searchList = data.VIEWCOUNT.slice(0, 6);
        // this.playList = data.PLAYCOUNT.slice(0, 6);
        // this.dowloadList = data.DOWNLOADS.slice(0, 6);
      }
    },
    getRankList: async function() {
      var res = await this.$http.get(
        `/v1/index/videoInfoByContentType?videoTypeId=${this.videoTypeId}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        // 热数据排行榜 DOWNLOADS PLAYCOUNT VIEWCOUNT
        this.searchList = data.VIEWCOUNT.slice(0, 6);
        this.playList = data.PLAYCOUNT.slice(0, 6);
        this.dowloadList = data.DOWNLOADS.slice(0, 6);
      }
    },
    // 绘制图表
    eConsole: function(param) {},
    creatE: async function() {
      await this.videoInfoGrossCount();
      var that = this;
      // 基于准备好的dom,初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      let chartPie = this.$echarts.init(document.getElementById("myChartPie"));
      // 绘制图表
      myChart.setOption(
        {
          // ----------
          color: ["#00aaff"],
          title: { text: "重点门类浏览总量" },
          dataset: {
            source: that.videoGrossCount.categoryCount
            // source: [
            //   {
            //     category: "书法",
            //     downloads: 6,
            //     proportion: 0,
            //     videocount: "3",
            //     viewcount: 13
            //   },
            //   {
            //     category: "戏剧",
            //     downloads: 2,
            //     proportion: 0,
            //     videocount: "1",
            //     viewcount: 27
            //   }
            // ]
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: {}
            }
          },
          grid: { containLabel: true },
          tooltip: {},
          xAxis: {
            show: true,
            axisLabel: "false",
            axisLine: {
              // x轴
              show: false
            },
            axisTick: {
              // x轴刻度线
              show: false
            },
            splitLine: {
              // 网格线
              show: true
            }
          },
          yAxis: {
            // show:false,
            position: "right",
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            },
            type: "category"
            // data: ["文学", "戏曲", "电影", "音乐", "曲艺", "舞蹈"]
          },
          series: [
            {
              type: "bar",
              encode: {
                x: "viewcount",
                y: "product"
              },
              name: "",
              // data: [133, 244, 355, 433, 54, 655, 733],
              label: {
                normal: {
                  show: true,
                  position: "left"
                }
              }
            }
          ]
        },
        true
      );
      myChart.on("click", param => {
        console.log(param.data);
        this.$router.push({
          path: "/searchpages",
          query: {
            category: param.data.category
          }
        });
      });
      // 重点门类视频数量
      chartPie.setOption(
        {
          title: {
            text: "重点门类视频数量",
            subtext: "",
            x: "center"
          },
          tooltip: {
            trigger: "item",
            // formatter: "{a} <br/>{b} : {c} ({d}%)"
            formatter: function(params) {
              var res = params.name + ":" + params.percent + "%" + "<br />";
              // var res = ''
              // console.log("ppp", params);
              return res;
            }
          },
          legend: {
            x: "center",
            y: "bottom",
            // type: 'scroll',
            // orient: 'vertical',
            // right:10,
            // top: 60,
            // bottom: 20,
            data: (function() {
              var arr = [];
              // console.log(that.videoGrossCount.categoryCount)
              that.videoGrossCount.categoryCount.forEach(item => {
                // console.log('iiiii',item)
                arr.push(item.category);
              });
              // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
              //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
              //   // arr.push(i.category)
              // }
              // console.log('aaaaa',arr)
              return arr;
            })()
          },
          toolbox: {
            show: true,
            feature: {
              magicType: {
                show: true,
                type: ["pie", "funnel"]
              },
              saveAsImage: { show: true }
            }
          },
          calculable: true,
          dataset: {
            source: that.videoGrossCount.categoryCount
          },
          series: [
            {
              name: "半径模式",
              type: "pie",
              // radius: [50, 180],
              radius: "70%",
              // center: ["50%", "50%"],
              // roseType: "angle",//南丁格尔图
              // roseType: "radius",//分块
              // roseType:'single',// 整圆
              label: {
                normal: {
                  // 显示数据
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              encode: {
                itemName: "category",
                value: "videocount"
              },
              // data: [
              //   { value: 20, name: "文学" },
              //   { value: 28, name: "戏曲" },
              //   { value: 12, name: "电影" },
              //   { value: 10, name: "音乐" },
              //   { value: 11, name: "曲艺" },
              //   { value: 19, name: "舞蹈" }
              // ],
              // data: that.videoGrossCount.categoryCount,
              // 自定义颜色的实现
              itemStyle: {
                normal: {
                  // 定义一个list，通过list获取颜色，
                  color: function(params) {
                    var colorList = [
                      "#7f68f6",
                      "#2cd9c5",
                      "#505d6f",
                      "#2d98fe",
                      "#ff6c40",
                      "#fee600",

                      "#37a2da",
                      "#32c5e9",
                      "#9fe6b8",
                      "#ffdb5c",
                      "#ff9f7f",
                      "#fb7293",

                      "#e7bcf3",
                      "#8378ea",

                      "#505d6f",
                      "#2d98fe",
                      "#ff6c40",
                      "#fee600"
                    ];
                    return colorList[params.dataIndex];
                  },
                  // 以下为是否显示，显示位置和显示格式
                  label: {
                    show: true,

                    position: "top",
                    //                             formatter: '{c}'
                    // formatter: "{b}\n{c}"
                    formatter: function(params) {
                      var res = params.name + " : " + params.data.videocount;
                      return res;
                    }
                  }
                }
              }
            }
            // {
            //   name: "面积模式",
            //   type: "pie",
            //   radius: [30, 110],
            //   center: ["75%", "50%"],
            //   roseType: "area",
            //   data: [
            //     { value: 10, name: "rose1" },
            //     { value: 5, name: "rose2" },
            //     { value: 15, name: "rose3" },
            //     { value: 25, name: "rose4" },
            //     { value: 20, name: "rose5" },
            //     { value: 35, name: "rose6" },
            //     { value: 30, name: "rose7" },
            //     { value: 40, name: "rose8" }
            //   ]
            // }
          ]
        },
        true
      );
      chartPie.on("click", param => {
        console.log(param.data);
        this.$router.push({
          path: "/searchpages",
          query: {
            category: param.data.category
          }
        });
      });
      // 重点门类下载总量图表
      myChart2.setOption(
        {
          color: ["#00aaff"],
          title: { text: "本月上传总量" },
          tooltip: {},
          toolbox: {
            show: true,
            feature: {
              magicType: {
                show: true,
                type: ["pie", "funnel"]
              },
              saveAsImage: { show: true }
            }
          },
          dataset: {
            source: that.videoGrossCount.categoryCount
          },
          grid: { containLabel: true },
          xAxis: {
            show: true,
            axisLabel: "false",
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            },
            type: "category"
            // data: []
          },
          series: [
            {
              type: "bar",
              encode: {
                x: "downloads",
                y: "category"
              },
              name: "上传量",
              label: {
                normal: {
                  show: true,
                  position: "right"
                }
              }
              // data: [1, 2, 3, 4, 5, 6, 7]
            }
          ]
        },
        true
      );
      myChart2.on("click", param => {
        console.log(param.data);
        this.$router.push({
          path: "/searchpages",
          query: {
            category: param.data.category
          }
        });
      });
      // 平台内天纬度总量
      // 1990 与 2015年各国家人均寿命与GDP

      // var data =[that.videoGrossCount.videoTagsCount,that.videoGrossCount.videoPersonCount,that.videoGrossCount.videoCharCount,that.videoGrossCount.videoCharCount]
    },
    initChart: function() {
      // 平台内天纬度总量 视频标签散点图
      var that = this;
      // console.log(this.tagType);

      if (this.tagType == 0) {
        let videoChart1 = that.$echarts.init(document.getElementById("vc1"));

        videoChart1.setOption(
          {
            title: {
              text: "视频标签关系图",
              x: "left"
            },
            animationDurationUpdate: 1500,
            animationEasingUpdate: "quinticInOut",
            series: [
              {
                type: "graph",
                layout: "none",
                // progressiveThreshold: 700,
                data: that.nodes.map(function(node) {
                  return {
                    x: node.x,
                    y: node.y,
                    id: node.id,
                    name: node.label,
                    symbolSize: node.size,
                    itemStyle: {
                      normal: {
                        color: node.color
                      }
                    }
                  };
                }),
                edges: that.edges.map(function(edge) {
                  return {
                    source: edge.sourceID,
                    target: edge.targetID
                  };
                }),
                label: {
                  emphasis: {
                    position: "right",
                    show: true
                  }
                },
                roam: true,
                focusNodeAdjacency: true,
                lineStyle: {
                  normal: {
                    width: 0.5,
                    curveness: 0.3,
                    opacity: 0.7
                  }
                }
              }
            ]
          },
          true
        );
      } else if (this.tagType == 1) {
        console.log("111");
        let videoChart2 = that.$echarts.init(document.getElementById("vc2"));
        videoChart2.setOption(
          {
            title: {
              text: "视频人物总量",
              subtext: "",
              x: "left"
            },
            tooltip: {
              trigger: "item",
              // formatter: "{a} <br/>{b} : {c} ({d}%)"
              formatter: function(params) {
                var res = params.name + ":" + params.percent + "%" + "<br />";
                // var res = ''
                // console.log("ppp", params);
                return res;
              }
            },
            legend: {
              x: "center",
              y: "bottom",
              // type: 'scroll',
              // orient: 'vertical',
              // right:10,
              // top: 60,
              // bottom: 20,
              data: (function() {
                var arr = [];
                // console.log(that.videoGrossCount.categoryCount)
                that.piedata.forEach(item => {
                  // console.log('iiiii',item)
                  arr.push(item.name);
                });
                // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
                //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
                //   // arr.push(i.category)
                // }
                // console.log('aaaaa',arr)
                return arr;
              })()
            },
            toolbox: {
              show: true,
              feature: {
                magicType: {
                  show: true,
                  type: ["pie", "funnel"]
                },
                saveAsImage: { show: true }
              }
            },
            calculable: true,
            dataset: {
              source: that.piedata
            },
            series: [
              {
                name: "视频人物总量图",
                type: "pie",
                // radius: [50, 180],
                radius: "70%",
                // center: ["50%", "45%"],
                // roseType: "angle",//南丁格尔图
                // roseType: "radius",//分块
                // roseType: "single", // 整圆
                label: {
                  normal: {
                    // 显示数据
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                lableLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                encode: {
                  itemName: "name",
                  value: "value"
                },
                // data: [
                //   { value: 20, name: "文学" },
                //   { value: 28, name: "戏曲" },
                //   { value: 12, name: "电影" },
                //   { value: 10, name: "音乐" },
                //   { value: 11, name: "曲艺" },
                //   { value: 19, name: "舞蹈" }
                // ],
                // data: that.videoGrossCount.categoryCount,
                // 自定义颜色的实现
                itemStyle: {
                  normal: {
                    // 定义一个list，通过list获取颜色，
                    color: function(params) {
                      var colorList = [
                        "#7f68f6",
                        "#2cd9c5",
                        "#505d6f",
                        "#2d98fe",
                        "#ff6c40",
                        "#fee600",

                        "#37a2da",
                        "#32c5e9",
                        "#9fe6b8",
                        "#ffdb5c",
                        "#ff9f7f",
                        "#fb7293",

                        "#e7bcf3",
                        "#8378ea",

                        "#505d6f",
                        "#2d98fe",
                        "#ff6c40",
                        "#fee600"
                      ];
                      return colorList[params.dataIndex];
                    },
                    // 以下为是否显示，显示位置和显示格式
                    label: {
                      show: true,

                      position: "top",
                      //                             formatter: '{c}'
                      // formatter: "{b}\n{c}"
                      formatter: function(params) {
                        var res = params.name + " : " + params.data.value;
                        return res;
                      }
                    }
                    // // 阴影的大小
                    // shadowBlur: 200,
                    // // 阴影水平方向上的偏移
                    // shadowOffsetX: 0,
                    // // 阴影垂直方向上的偏移
                    // shadowOffsetY: 0,
                    // // 阴影颜色
                    // shadowColor: "rgba(0, 0, 0, 0.5)"
                  }
                },
                animationType: "scale",
                animationEasing: "elasticOut"
              }
            ]
          },
          true
        );
      } else if (this.tagType == 2) {
        let videoChart3 = that.$echarts.init(document.getElementById("vc3"));
        console.log("222");
        videoChart3.setOption(
          {
            title: {
              // text: "重点门类视频数量",
              subtext: "",
              x: "left"
            },
            tooltip: {
              trigger: "item",
              // formatter: "{a} <br/>{b} : {c} ({d}%)"
              formatter: function(params) {
                var res = params.name + ":" + params.percent + "%" + "<br />";
                // var res = ''
                // console.log("ppp", params);
                return res;
              }
            },
            legend: {
              x: "center",
              y: "bottom",
              // type: 'scroll',
              // orient: 'vertical',
              // right:10,
              // top: 60,
              // bottom: 20,
              data: (function() {
                var arr = [];
                // console.log(that.videoGrossCount.categoryCount)
                that.piedata.forEach(item => {
                  // console.log('iiiii',item)
                  arr.push(item.name);
                });
                // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
                //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
                //   // arr.push(i.category)
                // }
                // console.log('aaaaa',arr)
                return arr;
              })()
            },
            toolbox: {
              show: true,
              feature: {
                magicType: {
                  show: true,
                  type: ["pie", "funnel"]
                },
                saveAsImage: { show: true }
              }
            },
            calculable: true,
            dataset: {
              source: that.piedata
            },
            series: [
              {
                name: "半径模式",
                type: "pie",
                radius: [50, 180],
                // radius: "70%",
                // center: ["50%", "50%"],
                roseType: "angle", // 南丁格尔图
                // roseType: "radius",//分块
                // roseType:'single',// 整圆
                label: {
                  normal: {
                    // 显示数据
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                lableLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                encode: {
                  itemName: "name",
                  value: "value"
                },
                // data: [
                //   { value: 20, name: "文学" },
                //   { value: 28, name: "戏曲" },
                //   { value: 12, name: "电影" },
                //   { value: 10, name: "音乐" },
                //   { value: 11, name: "曲艺" },
                //   { value: 19, name: "舞蹈" }
                // ],
                // data: that.videoGrossCount.categoryCount,
                // 自定义颜色的实现
                itemStyle: {
                  normal: {
                    // 定义一个list，通过list获取颜色，
                    color: function(params) {
                      var colorList = [
                        "#7f68f6",
                        "#2cd9c5",
                        "#505d6f",
                        "#2d98fe",
                        "#ff6c40",
                        "#fee600",

                        "#37a2da",
                        "#32c5e9",
                        "#9fe6b8",
                        "#ffdb5c",
                        "#ff9f7f",
                        "#fb7293",

                        "#e7bcf3",
                        "#8378ea",

                        "#505d6f",
                        "#2d98fe",
                        "#ff6c40",
                        "#fee600"
                      ];
                      return colorList[params.dataIndex];
                    },
                    // 以下为是否显示，显示位置和显示格式
                    label: {
                      show: true,

                      position: "top",
                      //                             formatter: '{c}'
                      // formatter: "{b}\n{c}"
                      formatter: function(params) {
                        var res = params.name + " : " + params.data.value;
                        return res;
                      }
                    }
                  }
                }
              }
              // {
              //   name: "面积模式",
              //   type: "pie",
              //   radius: [30, 110],
              //   center: ["75%", "50%"],
              //   roseType: "area",
              //   data: [
              //     { value: 10, name: "rose1" },
              //     { value: 5, name: "rose2" },
              //     { value: 15, name: "rose3" },
              //     { value: 25, name: "rose4" },
              //     { value: 20, name: "rose5" },
              //     { value: 35, name: "rose6" },
              //     { value: 30, name: "rose7" },
              //     { value: 40, name: "rose8" }
              //   ]
              // }
            ]
          },
          true
        );
      } else {
        let videoChart4 = that.$echarts.init(document.getElementById("vc4"));

        console.log("333");
        videoChart4.setOption(
          {
            title: {
              // text: "重点门类视频数量",
              subtext: "",
              x: "left"
            },
            tooltip: {
              trigger: "item",
              // formatter: "{a} <br/>{b} : {c} ({d}%)"
              formatter: function(params) {
                var res = params.name + ":" + params.percent + "%" + "<br />";
                // var res = ''
                // console.log("ppp", params);
                return res;
              }
            },
            legend: {
              x: "center",
              y: "bottom",
              // type: 'scroll',
              // orient: 'vertical',
              // right:10,
              // top: 60,
              // bottom: 20,
              data: (function() {
                var arr = [];
                // console.log(that.videoGrossCount.categoryCount)
                that.piedata.forEach(item => {
                  // console.log('iiiii',item)
                  arr.push(item.name);
                });
                // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
                //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
                //   // arr.push(i.category)
                // }
                // console.log('aaaaa',arr)
                return arr;
              })()
            },
            toolbox: {
              show: true,
              feature: {
                magicType: {
                  show: true,
                  type: ["pie", "funnel"]
                },
                saveAsImage: { show: true }
              }
            },
            calculable: true,
            dataset: {
              source: that.piedata
            },
            series: [
              {
                name: "半径模式",
                type: "pie",
                radius: [100, 180],
                // radius: "70%",
                // center: ["50%", "50%"],
                // roseType: "angle", //南丁格尔图
                // roseType: "radius",//分块
                // roseType:'single',// 整圆
                label: {
                  normal: {
                    // 显示数据
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                lableLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                encode: {
                  itemName: "name",
                  value: "value"
                },
                // data: [
                //   { value: 20, name: "文学" },
                //   { value: 28, name: "戏曲" },
                //   { value: 12, name: "电影" },
                //   { value: 10, name: "音乐" },
                //   { value: 11, name: "曲艺" },
                //   { value: 19, name: "舞蹈" }
                // ],
                // data: that.videoGrossCount.categoryCount,
                // 自定义颜色的实现
                itemStyle: {
                  normal: {
                    // 定义一个list，通过list获取颜色，
                    color: function(params) {
                      var colorList = [
                        "#7f68f6",
                        "#2cd9c5",
                        "#505d6f",
                        "#2d98fe",
                        "#ff6c40",
                        "#fee600",

                        "#37a2da",
                        "#32c5e9",
                        "#9fe6b8",
                        "#ffdb5c",
                        "#ff9f7f",
                        "#fb7293",

                        "#e7bcf3",
                        "#8378ea",

                        "#505d6f",
                        "#2d98fe",
                        "#ff6c40",
                        "#fee600"
                      ];
                      return colorList[params.dataIndex];
                    },
                    // 以下为是否显示，显示位置和显示格式
                    label: {
                      show: true,

                      position: "top",
                      //                             formatter: '{c}'
                      // formatter: "{b}\n{c}"
                      formatter: function(params) {
                        var res = params.name + " : " + params.data.value;
                        return res;
                      }
                    }
                  }
                }
              }
              // {
              //   name: "面积模式",
              //   type: "pie",
              //   radius: [30, 110],
              //   center: ["75%", "50%"],
              //   roseType: "area",
              //   data: [
              //     { value: 10, name: "rose1" },
              //     { value: 5, name: "rose2" },
              //     { value: 15, name: "rose3" },
              //     { value: 25, name: "rose4" },
              //     { value: 20, name: "rose5" },
              //     { value: 35, name: "rose6" },
              //     { value: 30, name: "rose7" },
              //     { value: 40, name: "rose8" }
              //   ]
              // }
            ]
          },
          true
        );
      }
    },

    // 获取热数据排行榜
    // 平台纬度点击
    clickWdTab: function(index) {
      this.wdId = index;
      this.tagType = index;
      // console.log(this.tagType)
      this.getTagChart();
    },
    getTagChart: async function() {
      var res = await this.$http.get(`/v1/index/TagChart?type=${this.tagType}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.piedata = data;
        this.nodes = data.nodes;
        this.edges = data.edges;
        setTimeout(() => {
          this.initChart();
          // console.log(data.nodes);
        }, 200);
      }
    }
  },
  mounted: function() {
    this.creatE();
    this.getTagChart();
    // this.videoInfoGrossCount();
    this.getListByContent();
    this.getRankList();
    this.getFlowsList();
    var uuser = window.localStorage.getItem('userid')
    // console.log(uuser )
    this.roleId =this.$store.state.userInfo.roleid || uuser
      
  }
};
</script>

<style lang="scss" scoped>
.flows {
  background-color: pink;
}
.news {
  background-color: #bbc5e2;
}
.live {
  background-color: #80dac4;
}
.view {
  background-color: #b1df90;
}
.work {
  background-color: #f7bb9e;
}
.other {
  background-color: #d9beec;
}
.bg-time {
  background-color: #e7fbf6;
}
.bg-size {
  background-color: #e9fcc6;
}
.bg-total {
  background-color: #ffefdf;
}
.text-color {
  color: #a2abb5;
}
.red {
  color: #f45252;
}
.bg-video {
  background-color: #f0efff;
}
.bg-yellow {
  background-color: #f5a623;
}
.bg-gary {
  background-color: #c1c7ce;
}
.pc-home {
  margin-top: 30px;
  .el-card {
    border-radius: 0 0 10px 10px;
  }
  .el-card__body {
    padding: 0px;
  }
  .top_nav {
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .el-image {
      width: 30px;
      height: 30px;
      vertical-align: middle;
    }
    .nn {
      height: 90px;
      width: 590px;
      // padding: 0 240px;
      line-height: 90px;
      text-align: left;
      font-size: 20px;
      // background: #e6e9eb;
      background-color: #e2e8ef;
      font-weight: bold;
      padding: 0 30px;
      color: #2a3541;
      border-radius: 10px 10px 0 0;
      &:hover {
        cursor: pointer;
      }
    }
    .active {
      background-color: #fff;
      color: #2a3541;
      font-size: 22px;
      border: 1px solid #ccc;
      border-bottom: none;
    }
  }
  .h-box {
    padding: 10px 0px;
    // background-color: #fff;
    .h-li {
      cursor: pointer;
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 146px;
      line-height: 146px;
      border-radius: 5px;
      background-color: #f2f5f8;
      .li_title {
        width: 41px;
        // background-color: #bbc5e2;
        color: #fff;
        height: 100%;
        padding: 20px 10px;
        font-size: 20px;
        text-align: center;
        line-height: 35px;
        border-radius: 5px 0 0 5px;
        font-weight: bold;
      }
      .li_type {
        width: 180px;
        padding: 20px 30px;
        text-align: left;
        line-height: 20px;
        font-size: 20px;
        font-weight: bold;
        .el-image {
          width: 30px;
          height: 30px;
        }
        .red {
          // color: rgba(153, 0, 0, 0.65);
          color: #000;
          font-weight: bold;
          margin-top: 20px;
        }
      }
      .li_image {
        padding: 20px 15px;

        .li {
          width: 155px;
          height: 90px;
          line-height: 90px;
          float: left;
          vertical-align: middle;
          margin-right: 20px;

          .li-box {
            width: 155px;
            height: 87px;
          }
          .li-title {
            line-height: 40px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  // 平台视频数据总量
  .database {
    margin-top: 90px;
    .data-title {
      .el-image {
        width: 27px;
        height: 27px;
      }
    }
    .data-tab {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .tab-box {
        display: flex;
        flex-direction: row;
        width: 253px;
        height: 80px;
        line-height: 30px;
        text-align: center;
        background-color: #fff;
        box-shadow: 2px 2px 2px #f1f5f9;
        .tab-img {
          width: 80px;
          height: 80px;
          line-height: 80px;
          vertical-align: middle;
          // background-color: #e7fbf6;
          .el-image {
            width: 30px;
            height: 30px;
            margin-top: 25px;
          }
        }
      }
    }
    .data-chart {
      margin-top: 50px;
      .el-col {
        border-right: 1px solid #555;
        padding: 10px;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  // 热数据排行榜
  .data-rank {
    background-color: #f2f8ff;
    padding: 20px 0 100px 0;
    margin-top: 90px;
    .data-title {
      padding: 90px 0px 50px 0px;
      .el-image {
        width: 27px;
        height: 27px;
      }
    }
    .rank-list {
      background-color: #fff;
      display: flex;
      flex-direction: row;
      padding: 30px;
      .top-title {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        div {
          margin: auto 5px;
        }
        .el-image {
          width: 50px;
          height: 40px;
          vertical-align: middle;
        }
      }
      .top-box {
        .top-li {
          display: flex;
          flex-direction: row;
          padding: 5px 10px;
          min-height: 130px;
          .li-img {
            position: relative;
            
            .li-num {
              width: 30px;
              height: 26px;
              border-radius: 5px 0 5px 0;
              // background-color: #f5a623;
              // background-color: #c1c7ce;

              left: 0px;
              top: 0px;
              position: absolute;
              text-align: center;
              color: #fff;
              font-size: 18px;
            }
          }
          .el-image {
            width: 135px;
            height: 96px;
            border-radius: 5px;
          }
          .li-text {
            padding: 0 10px;
            h3{
              font-size: 16px;
            }
            .text-color{
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            h4 {
              font-size: 16px;
              text-align: left;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
    .ranlActive {
      background-color: #fff;
      color: #2a3541;
      font-size: 22px;
    }
  }
  //平台内容纬度总量
  .wd-adtive {
    background-color: #e5f6ff;
    // color: #4fb850;
    border-right: 2px solid #00a9ff;
    font-weight: bold;
  }
  .data-wd {
    .data-title {
      padding: 90px 0px 50px 0px;
      .el-image {
        width: 27px;
        height: 27px;
      }
    }
    .wd-left {
      height: 400px;
      border-right: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: space-around;
      .wd-tab {
        padding: 10px 20px;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
  // 分页
}
</style>
<style>
/* 分页 */
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: #fff !important;
  border: 1px solid #ccc !important;
  border-radius: 5px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00aaff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/main.vue